import banner from "../../assets/images/fellowship.jpg";
import Navbar from "../Navbar/Navbar";
export default function Fellowship() {
  return (
    <section
      id="completed-project-inner-section"
      className="completed-project-inner-section inner-banner mb-5">
      <Navbar />
      <div className="page-title-area">
        <div className="container-fluid pe-4 h-100 d-flex justify-content-end align-items-end">
          <div className="page-title-content">
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>Beyond Eyes Experience</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="container pt-5">
        <div className="row">
          <div className="col-12">
            <div className="text-center">
              <img
                src={banner}
                className="img-fluid mx-auto"
                alt="Try it out! Beyond Eyes Experience is a
Immersive Dark Room Experience that reveals the challenges faced by the
blind every day. Guided only by senses of touch, sound, smell & intuition
Gain a deeper understanding of empathy, perception, and the power of
human connection."
              />
            </div>
            <div className="main-heading pb-1 mb-4 mt-lg-4 text-center">
              <h1 className="main-title wow animate__animated animate__fadeInUp">
                Fellowship
              </h1>
            </div>
            <h5>
              What if just 2–10 hours a week could help make the world more
              accessible and inclusive?
            </h5>
            <p>
              The NAB Delhi Volunteer Fellowship for Social Change is an
              opportunity for passionate students, professionals, entrepreneurs,
              creatives, and changemakers to use their skills for a purpose that
              truly matters.
            </p>
            <p>
              Whether you're interested in communication, content writing,
              fundraising, partnerships, HR, research, accessibility, graphic
              design, or technology, your contribution can help empower persons
              with visual impairment and multiple disabilities to lead more
              independent and fulfilling lives.
            </p>

            <h2>Why join?</h2>
            <p>Create meaningful social impact</p>
            <p>Learn from experienced professionals</p>
            <p>Build your portfolio and professional network</p>
            <p>Receive a Fellowship Certificate & Letter of Appreciation</p>
            <p>
              Be part of a community that believes in inclusion and equal
              opportunities
            </p>
            <p>
              <strong>
                {" "}
                Commitment: Just 2–10 hours per week for a minimum of 3 months.
              </strong>
            </p>
            <p>
              Every great movement begins with people who choose to care. Your
              knowledge, creativity, and compassion can help build a future
              where everyone has the opportunity to thrive.
            </p>
            <p>Be the change. Volunteer. Inspire. Empower.</p>

            <p>
              Stay tuned to our website and social media  to know for fellowship
              vacancies.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
